/* This is ment to build provide a quick starting point when starting new index type file */
import React from 'react';
import supportPageStyle from './style';
import ContactForm from '../../components/ContactForm';

export default function SupportPage({mt}) {
	let style = supportPageStyle();

	return <ContactForm title={'Need Technical Support?'} text={'We are here to help.'} mt={mt} />;
}
